
/**
 * Get query variable
 * @param queryString Query string
 * @param variable Variable
 */
export function getQueryVariable(queryString: string, variable: string) {
  const variables = queryString.split('&');

  for (const queryVariable of variables) {
    const pair = queryVariable.split('=');

    if (decodeURIComponent(pair[0]) === variable) {
      return decodeURIComponent(pair[1]);
    }
  }
}
